import AmazonPayButton from './AmazonPayButton';
import AmazonPayCheckout from './AmazonPayCheckout';
import AmazonPayPaymentSelection from './AmazonPayPaymentSelection';

/**
 * AmazonPay scripts
 */
class AmazonPay {
  /**
   * Constructs
   * @param {Object} opts opts
   * @param {jQuery} $ jquery
   * @param {Object} SGEvent SGEvent
   * @param {Object} SGAction SGAction
   * @param {Object} sgData sgData
   * @param {Object|null} sgWebStorage sgData
   */
  constructor(opts, $, SGEvent, SGAction, sgData, sgWebStorage = null) {
    this.Button = new AmazonPayButton(opts, $, SGEvent, SGAction, sgData, sgWebStorage);
    this.Checkout = new AmazonPayCheckout(opts, $, SGEvent, SGAction, sgData, sgWebStorage);
    this.PaymentSelection = new AmazonPayPaymentSelection(opts, $, SGEvent, SGAction, sgData, sgWebStorage);
  }
}

export default AmazonPay;



// WEBPACK FOOTER //
// ./Library/1.0/app/amazon-pay/AmazonPay.js